<div class="card">
    <div class="title mt-2">Notification Settings</div>
    <div class="text mt-2">
        By default, designer will be notified by your company's preferred dark pattern. Employees can also customize their
        notification preferences by logging into their account.  
    </div>

    <div class="mt-3">
        <div class="toggle-title">PRIMARY SETTINGS</div>
        <div class="settings-box mt-1 flex-btw">
            <div class="flex-btw">
                <div style="margin-right: 10px;"><mat-icon fontSet="material-icons-outlined" style="color: grey;">settings</mat-icon></div>
                <div>
                    <div style="font-size: 15px; font-weight: 500;">
                        Settings option disabled
                    </div>
                    <div style="font-size: 13px; font-weight: 400; color: grey;">
                        Describe here what it is for
                    </div>
                </div>
            </div>

            <div>
                <mat-slide-toggle color="primary"></mat-slide-toggle>
            </div>
        </div>

        <div class="settings-box mt-1 flex-btw">
            <div class="flex-btw">
                <div style="margin-right: 10px;"><mat-icon fontSet="material-icons-outlined" style="color: grey;">title</mat-icon></div>
                <div>
                    <div style="font-size: 15px; font-weight: 500;">
                        Automatic text alignment
                    </div>
                    <div style="font-size: 13px; font-weight: 400; color: grey;">
                        This is a useful experimantal feature
                    </div>
                </div>
            </div>

            <div>
                <mat-slide-toggle color="primary"></mat-slide-toggle>
            </div>
        </div>
    </div>

    <div class="mt-2">
        <div class="toggle-title">SECONDARY SETTINGS</div>
        <div class="settings-box mt-1 flex-btw">
            <div class="flex-btw">
                <div style="margin-right: 10px;"><mat-icon fontSet="material-icons-outlined" style="color: grey;">settings</mat-icon></div>
                <div>
                    <div style="font-size: 15px; font-weight: 500;">
                        Settings option disabled
                    </div>
                    <div style="font-size: 13px; font-weight: 400; color: grey;">
                        Here is the onhovered statement
                    </div>
                </div>
            </div>

            <div>
                <mat-slide-toggle color="primary"></mat-slide-toggle>
            </div>
        </div>

        <div class="settings-box mt-1 flex-btw">
            <div class="flex-btw">
                <div style="margin-right: 10px;"><mat-icon fontSet="material-icons-outlined" style="color: grey;">delete</mat-icon></div>
                <div>
                    <div style="font-size: 15px; font-weight: 500;">
                        Automatically delete items
                    </div>
                    <div style="font-size: 13px; font-weight: 400; color: grey;">
                        Get rid of stuff and keep working hard
                    </div>
                </div>
            </div>

            <div>
                <mat-slide-toggle color="primary"></mat-slide-toggle>
            </div>
        </div>

    </div>

    <div class="mt-3">
        <button mat-flat-button color="primary">
            Save Changes
        </button>
    </div>

    



</div>
